import { Button as AntdButton, Button, Radio as RadioComponent } from 'antd';
import {
  BREAKPOINTS,
  BREAKPOINTS_NUM,
} from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const PackingButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;

  @media (max-width: ${BREAKPOINTS_NUM.tablet - 1}px) {
    padding: 14px 0;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    .sale-type-label {
      margin-right: 0;

      span {
        padding: 0;
        padding-right: 8px;
      }
    }
  }
`;

export const Radio = styled(RadioComponent)`
  font-family: Roboto;
  letter-spacing: 0%;
  color: #8c8c8c;
`;

export const Monetary = styled.div<{ isChecked?: boolean }>`
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-top: 4px;
  color: ${(props) => (props.isChecked ? '#F78E1E' : '#000000')};
`;

export const Divider = styled.div`
  height: 50%;
  border-right: solid 1px #f0f0f0;
  position: relative;
  margin-right: 8px;
  top: 8px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    display: grid;
    grid-template-columns: 1fr minmax(auto, 300px);
    grid-template-areas:
      'controls buttons'
      'controls buttons';
    gap: 16px;
    align-items: start;
  }
`;

export const ControlsSection = styled.div`
  display: contents;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    grid-area: controls;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  align-items: flex-start;
  margin: 0;
  padding: 4px 0;

  .ant-radio {
    .ant-radio-inner {
      width: 16px;
      height: 16px;
      border: 2px solid #d9d9d9;
      border-radius: 50%;
      background-color: transparent;

      &::after {
        width: 8px;
        height: 8px;
        background-color: #f78e1e;
        border-radius: 50%;
        transform: scale(0);
        transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
        margin-top: -4px;
        margin-left: -4px;
      }
    }

    &.ant-radio-checked {
      .ant-radio-inner {
        border: 2px solid #f78e1e;
        background-color: transparent;

        &::after {
          transform: scale(1);
        }
      }
    }

    &:hover .ant-radio-inner {
      border-color: #f78e1e;
    }

    &:focus .ant-radio-inner {
      border-color: #f78e1e;
      box-shadow: 0 0 0 2px rgba(247, 142, 30, 0.2);
    }
  }

  .ant-radio-disabled {
    .ant-radio-inner {
      background-color: #f5f5f5;
      border-color: #d9d9d9;

      &::after {
        background-color: #bfbfbf;
      }
    }
  }
`;

export const ButtonsSection = styled.div`
  display: contents;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    grid-area: buttons;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 140px;
    margin-top: auto;
    padding-bottom: 24px;
  }
`;

export const SaleTypeGrid = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  gap: 4px;
  width: 100%;
`;

export const InfoRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #595959;
  flex-wrap: wrap;
  gap: 6px;
`;

export const InfoDivider = styled.span`
  color: #d9d9d9;
`;

export const PromoInfoRow = styled.div`
  font-size: 10px;
  color: #389e0d;
  max-width: 200px;
  word-wrap: break-word;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    display: none;
  }
`;

export const VoucherInfoRow = styled.div`
  font-size: 10px;
  color: #389e0d;
  max-width: 280px;
  word-wrap: break-word;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    display: none;
  }
`;

export const ShippingFee = styled.span`
  color: #f78e1e;
  font-weight: 600;
  font-size: 10px;
  background: #fdf1e3;
  padding: 1px 8px;
  border-radius: 4px;
`;

export const DetailsLinkButton = styled(AntdButton)`
  border: 1px solid #f78e1e;
  color: #f78e1e;
  text-align: center;
  width: 100%;
  height: 32px;
  font-size: 0.875rem;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover,
  &:focus {
    border-color: #f78e1e;
    color: #f78e1e;
  }

  .desktop-text {
    display: none;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    .desktop-text {
      display: block;
    }

    .mobile-text {
      display: none;
    }
  }
`;

export const BuyButton = styled(Button)`
  color: white;
  width: 100%;

  svg path {
    fill: currentColor;
  }
`;

export const ButtonTooltipWrapper = styled.span<{ isDisabled?: boolean }>`
  display: block;
  width: 100%;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'auto')};

  > button {
    width: 100%;
    ${({ isDisabled }) => (isDisabled ? 'pointer-events: none;' : '')}
  }
`;

export const ButtonsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const CartText = styled.span`
  margin-right: 4px;
`;

export const CompositionLine = styled.div`
  font-size: 10px;
  color: #262626;
  font-weight: normal;
`;

export const TotalPedidoLine = styled.div`
  font-size: 11px;
  color: #262626;
  font-weight: 600;
  margin-top: 4px;
  padding: 6px 10px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
`;
